import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { KycQuestionnaireSendWidget } from "../../widgets/kycQuestionnaire/send";

export const KycQuestionnaireSendPage = () => {
  const { _id } = useParams<{ _id: string }>();
  useEffect(() => {
    document.title = "KYC Судалгаа илгээх";
  }, []);
  return (
    <div className="page">
      <KycQuestionnaireSendWidget _id={_id} />
    </div>
  );
};
